<template>
    <navigation />

    <promo-header />

    <section class="section section-blue">

        <div class="container">

            <div class="row">

                <div class="col-lg-8">
                    <h2 class="mb-4">
                        David
                    </h2>

                    <h5>Series Aims</h5>
                    <ul>
                        <li>
                            To understand that Jesus is God’s chosen king from David’s line who will rescue his people from their greatest enemy and rule over them forever.
                        </li>
                        <li>
                            To understand that the right response to God’s chosen king is to love, trust, serve and obey him.
                        </li>
                        <li>
                            To understand that our sin has consequences, but that God will forgive all those who truly repent and trust in Jesus.
                        </li>
                        <li>
                            To understand that God powerfully equips his people by his Spirit and uses them to achieve his purposes.
                        </li>
                    </ul>

                    <h5 class="mt-4">Series Overview</h5>
                    <p>
                        This series covers David’s anointing as king; his flight from King Saul; the establishment of his rule over Israel; and God’s promise to continue David’s line forever. It looks at David’s kingship from two different perspectives:
                    </p>
                    <p>
                        A good king – David was a man after God’s own heart, chosen by him and faithful to him (week 1). He trusted in God and obeyed him, even in times of great testing (weeks 1, 2, 4 and 5). He was equipped to rule by God’s Spirit (week 1) and he was loved by his people (weeks 3 and 4). In many ways David was a model king for all those who would come after him.
                    </p>
                    <p>
                        A better king – David, however, was still human. Though he repented of his sin and was forgiven, he still disobeyed God at times (week 6). David was God’s chosen king, but he was only a shadow of a better king to come – one who would come from his own line and would rule perfectly over his people forever (week 5).
                    </p>
                    <p>
                        David stands in complete contrast to Israel’s previous king, Saul. He loved God, kept his word, trusted his promises and ruled wisely. Both his successes and his failings therefore clearly teach us about the kind of king that Jesus is; as wonderful as David was, Jesus is better! The only appropriate response to such a king is to love, trust, serve and obey him wholeheartedly as we wait for his return.
                    </p>

                    <h5 class="mt-4">Series Outline</h5>
                    <p>
                        Lesson 1 - Chosen (1 Samuel 16:1-13)
                    </p>
                    <p>
                        Lesson 2 - Victorious (1 Samuel 17:1-58)
                    </p>
                    <p>
                        Lesson 3 - Hunted (1 Samuel 18:6-16, 19:1-10, 20:1-42)
                    </p>
                    <p>
                        Lesson 4 - Merciful (1 Samuel 24:1-22, 26:1-25)
                    </p>
                    <p>
                        Lesson 5 - Promised (2 Samuel 5:1-5, 7:1-29)
                    </p>
                    <p>
                        Lesson 6 - Forgiven (2 Samuel 11:1-12:25)
                    </p>

                </div>

                <div class="offset-lg-1 col">

                    <promo-sidebar />

                </div>

            </div>

        </div>

    </section>

    <site-footer />
</template>

<script >
import Navigation from "../partials/Navigation.vue";
import SiteFooter from "../partials/SiteFooter.vue";
import PromoHeader from "../partials/PromoHeader.vue";
import PromoSidebar from "../partials/PromoSidebar.vue";

export default {
    name: "David",

    components: {
        PromoSidebar,
        PromoHeader,
        Navigation,
        SiteFooter,
    },

    head() {
        return {
            title: `${this.$app.appName} - David`,
            meta: [
                {
                    name: 'description',
                    content: "To understand that Jesus is God’s chosen king from David’s line who will rescue his people from their greatest enemy and rule over them forever.",
                },
            ],
        };
    },
};
</script>
